import React, { useState } from 'react';
import clsx from 'clsx';
import { Hero } from '../../components/Hero';
import Agenda from '../../components/Agenda';
import { ApplySection } from '../../components/ApplySection';
import Categories from '../../components/Categories';
import { categories } from '../../helpers';
import SearchInput from '../../components/SearchInput';
import Switch from '../../components/Switch';
import CheckItem from '../../components/CheckItem';
import PersonImg from '../../assets/images/agenda/person.png';
import { Accordion } from '../../components/Accordion';
import ChevronRightIcon from '../../assets/icons/chevron-right.svg';
import './agenda.css';

const tabs = [
  {
    id: 0,
    text: 'Monday 7',
  },
  {
    id: 1,
    text: 'Tuesday 8',
  },
  {
    id: 2,
    text: 'Wednesday 9',
  },
];

const schedules = [
  {
    id: 0,
    time: '7:00 AM - 8:30 AM',
    title: 'Breakfast & Networking'
  },
  {
    id: 1,
    time: '4:00 PM - 7:00 PM',
    title: 'Machine Learning: Enabling new products for Underserved People',
    content: 'Advances in machine learning and the availability of new data sources are enabling new types of businesses and products for traditionally underserved people.',
    position: 'Deputy General Counsel',
    company: 'OpenAi',
    categories: [
      'ai fundamentals',
      'automotive',
      'generative ai'
    ],
    photo: PersonImg,
  },
  {
    id: 2,
    time: '9:00 AM - 10:00 AM',
    title: 'Machine Learning: Enabling new products for Underserved People',
    content: 'Advances in machine learning and the availability of new data sources are enabling new types of businesses and products for traditionally underserved people.',
    position: 'Deputy General Counsel',
    company: 'OpenAi',
    categories: [
      'ai fundamentals',
      'automotive',
      'generative ai'
    ],
    photo: PersonImg,
  },
  {
    id: 3,
    time: '10:55 AM - 11:15 AM',
    title: 'Effective AI at Scale'
  },
  {
    id: 4,
    time: '9:00 AM - 10:00 AM',
    title: 'Machine Learning: Enabling new products for Underserved People',
    content: 'Advances in machine learning and the availability of new data sources are enabling new types of businesses and products for traditionally underserved people.',
    position: 'Deputy General Counsel',
    company: 'OpenAi',
    categories: [
      'ai fundamentals',
      'automotive',
      'generative ai'
    ],
    photo: PersonImg,
  },
  {
    id: 5,
    time: '9:00 AM - 10:00 AM',
    title: 'Machine Learning: Enabling new products for Underserved People',
    content: 'Advances in machine learning and the availability of new data sources are enabling new types of businesses and products for traditionally underserved people.',
    position: 'Deputy General Counsel',
    company: 'OpenAi',
    categories: [
      'ai fundamentals',
      'automotive',
      'generative ai'
    ],
    photo: PersonImg,
  },
]

const tracks = [
  {
    id: 0,
    title: 'Innovation Stage',
    text: 'This track was designed to showcase the industry’s leading AI startups and also provide a VC perspective on industry trends. All companies showcased in this track are handpicked by the Ai4 team as the up-and-comers to be on the lookout for. Most of these sessions will be conducted in a shorter 10-minute pitch-style format.'
  },
  {
    id: 1,
    title: 'Cross-Industry Tracks',
    text: 'Talks within these track are suggested for everyone & require no technical expertise. The focus here is broader in scope and with conversations relevant to every industry.',
    sections: [
      {
        title: 'Ai Ethics and Social Impact with AI',
      },
      {
        title: 'AI Fundamentals',
        body: {
          text: 'Public and private sector leaders explore one of the most important conversations for society today. Themes span the ethical and social impact of AI on the world, and modern regulatory and compliance standards around AI.',
          list_title: 'Topics include...',
          list_items: [
            'What is AI Ethics?',
            'Doing Good with AI',
            'Avoiding Harm from AI',
            'Public Policy and AI',
            'Model Explainability',
            'Compliance & Regulation',
            'Social Impact',
            'Model Bias',
            'Privacy'
          ]
        }
      },
      {
        title: 'Future of Humankind',
      },
      {
        title: 'Ai Ethics and Social Impact with AI',
        body: {
          text: 'Public and private sector leaders explore one of the most important conversations for society today. Themes span the ethical and social impact of AI on the world, and modern regulatory and compliance standards around AI.',
          list_title: 'Specific topics include...',
          list_items: [
            'What is AI Ethics?',
            'Doing Good with AI',
            'Avoiding Harm from AI',
            'Public Policy and AI',
            'Model Explainability',
            'Compliance & Regulation',
            'Social Impact',
            'Model Bias',
            'Privacy'
          ]
        },
      },
      {
        title: 'AI Research',
      },
      {
        title: 'All Things Data',
      },
      {
        title: 'Computer Vision',
      },
      {
        title: 'ML Ops & Platforms',
      },
      {
        title: 'NLP',
      },
      {
        title: 'Prediction and Time Series',
      },
      {
        title: 'Recommender Systems',
        body: {
          text: 'Public and private sector leaders explore one of the most important conversations for society today. Themes span the ethical and social impact of AI on the world, and modern regulatory and compliance standards around AI.',
          list_title: 'Specific topics include...',
          list_items: [
            'What is AI Ethics?',
            'Doing Good with AI',
            'Avoiding Harm from AI',
            'Public Policy and AI',
            'Model Explainability',
            'Compliance & Regulation',
            'Social Impact',
            'Model Bias',
            'Privacy'
          ]
        }
      },
      
    ]
  },
  {
    id: 2,
    title: 'Industry Tracks',
    text: 'Our industry tracks include topics & use cases specific to your industry. No technical expertise required. These tracks were designed for our executive-level attendees holding non-technical roles. Click to expand and read more…',
    sections: [
      {
        title: 'Automotive',
      },
      {
        title: 'Blockchain',
      },
      {
        title: 'Consumer Electronics',
      },
      {
        title: 'Cybersecurity',
      },
      {
        title: 'Finance',
      },
      {
        title: 'Government',
      },
      {
        title: 'Healthcare',
      },
      {
        title: 'HR & Recruiting',
      },
      {
        title: 'Insurance',
      },
      {
        title: 'Legal',
      },
      {
        title: 'Manufacturing',
      },
      {
        title: 'Marketing & Customer Experience',
      },
      {
        title: 'Media & Entertainment',
      },
      {
        title: 'Retail',
      },
      {
        title: 'Supply Chain & Logistics',
        body: {
          text: 'Public and private sector leaders explore one of the most important conversations for society today. Themes span the ethical and social impact of AI on the world, and modern regulatory and compliance standards around AI.',
          list_title: 'Specific topics include...',
          list_items: [
            'What is AI Ethics?',
            'Doing Good with AI',
            'Avoiding Harm from AI',
            'Public Policy and AI',
            'Model Explainability',
            'Compliance & Regulation',
            'Social Impact',
            'Model Bias',
            'Privacy'
          ]
        }
      },
    ]
  }
];

function AgendaPage() {
  const [values, setValues] = useState(categories);
  const [isEventScheduled, setIsEventScheduled] = useState(false);
  const [selectedTab, setSelectedTab] = useState(1);
  const selectedCategories = values.filter(item => item.checked);
  const filtered = schedules.filter(item => !item.categories || (item.categories && item.categories.findIndex(catItem => selectedCategories.findIndex(indexItem => indexItem.label.toLowerCase() === catItem.toLowerCase()) > -1) > -1))

  const onItemClose = (index) => {
    values[index].checked = !values[index].checked;
    setValues([...values]);
  }

  return (
    <div className="agenda">
      <div className="agenda-hero-wrapper">
        <Hero
          title="Agenda"
          description="Plan Your Conference Experience with Ease. Explore the sessions and tracks at Ai4 2024. Stay tuned for the detailed agenda, which includes speaker session times, and valuable insights."
          buttonLabel="VIEW ALL THE TRACKS"
        />
        <div className="agenda-row">
          <Agenda />
        </div>
      </div>
      <div className="row flex-start-row">
        <div className="agenda-left">
          <SearchInput placeholder="Search" />
          <div className="row space-between left-check-row">
            Schedule of Events
            <Switch onToggle={() => setIsEventScheduled(!isEventScheduled)} isOn={isEventScheduled}  />
          </div>
          <hr className="hr" />
          <Categories values={values} onChange={(value) => setValues(value)} />
        </div>
        <div className="agenda-right">
          <div className="agenda-right-tabs row">
            {
              tabs.map((tab) => (
                <button
                  className={clsx('tab', tab.id === selectedTab && 'selected')}
                  onClick={() => setSelectedTab(tab.id)}
                  key={tab.id}
                >
                  {tab.text}
                </button>
              ))
            }
          </div>
         
          <div className="agenda-right-content">
            <div className="row flex-wrap gap-4">
              <CheckItem onClick={() => {}} label="Clear All" isClear></CheckItem>
              {
                values.map((category, index) => (
                  category.checked && <CheckItem onClick={() => onItemClose(index)} label={category.label} key={index} />
                ))
              }
            </div>
            {
              filtered.map(item => (
                <div className={clsx('schedule', item.content && 'schedule-bordered')} key={item.id}>
                  <h3 className="schedule-time">
                    {item.time}
                  </h3>
                  <h4 className="schedule-title">
                    {item.title}
                  </h4>
                  {
                    item.content ? <p className="body-16">{item.content}</p> : null
                  }
                  
                  {
                    item.photo ? <div className="row">
                      <img src={item.photo} alt="Person" />
                      <p className="schedule-person">
                        {item.position}
                        <br/>
                        <b>{item.company}</b>
                      </p>
                    </div> : null
                  }
                  {
                    item.categories ? <p className="schedule-categories">{item.categories.join(' / ')}</p> : null
                  }
                </div>
              ))
            }
          </div>
        </div>
      </div>
      <div className="agenda-tracks">
        <h1>Tracks</h1>
        <p className="body-16">Discover the latest trends, advancements, and best practices shaping the future of AI as industry experts, government organizations, disruptive startups, investors, research labs.</p>
        <div className="agenda-tracks-content">
          {
            tracks.map(track => (
              <div id={track.id}>
                <h3>{track.title}</h3>
                <p className="body-16 track-text">{track.text}</p>
                {
                  track.sections ? <>
                  {
                    track.sections.map((section, index) => (
                      <Accordion
                        open={false}
                        header={(isOpen) => (
                          <div className={clsx('track-header', isOpen && 'track-open')}>
                            <img src={ChevronRightIcon} alt="Chevron Right" className={clsx(isOpen && 'section-expanded')}/>
                            {section.title}
                          </div>
                        )}
                        key={index}
                      >
                        {
                          section.body ? (
                            <div className="track-body">
                              <p className="body-16">{section.body.text}</p>
                              <div className="track-body-right">
                                <b>{section.body.list_title}</b>
                                <ul>
                                  {section.body.list_items.map(item => (
                                    <li>
                                      {item}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          ) : null
                        }
                      </Accordion>
                    ))
                  }
                  </> : null
                }
              </div>
            ))
          }
        </div>
      </div>
      <ApplySection
        title="Have questions?"
        description="Speak at Ai4 and become part of AI industry history. People attend Ai4 to learn how AI will impact their industry, their company, their career, and the world at large."
        buttonLabel="CONTACT US"
        inputPlaceholder="Your Email"
      />
    </div>
  );
}

export default AgendaPage;
